export enum PasswordValidationError {
  none = 'NONE',
  passwordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH',
  tooShort = 'TOO_SHORT',
  noSpecialCharacter = 'NO_SPECIAL_CHARACTER',
  noNumber = 'NO_NUMBER',
}

export function validatePassword(password: string): PasswordValidationError {
  if (password.length < 8) {
    return PasswordValidationError.tooShort;
  }

  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    return PasswordValidationError.noSpecialCharacter;
  }

  if (!/\d/.test(password)) {
    return PasswordValidationError.noNumber;
  }

  return PasswordValidationError.none;
}
